import { useTranslation } from "react-i18next";

import { languageName } from "astrid-helpers/src/languages";

import useArticleDeliveryStatuses from "./useArticleDeliveryStatuses";
import useArticleStatusTranslations from "./useArticleStatusTranslations";
import useArticleTypeTranslations from "./useArticleTypeTranslations";
import usePublicationStatuses from "./usePublicationStatuses";

export default function useArticlesRefinements({ organization, channels }) {
	const { t } = useTranslation();

	const articleTypeTranslations = useArticleTypeTranslations();
	const articleStatusTranslations = useArticleStatusTranslations();
	const deliveryStatuses = useArticleDeliveryStatuses();

	const publicationStatuses = usePublicationStatuses();
	const publicationStatusTranslations = Object.entries(publicationStatuses).reduce(
		(acc, [key, { text }]) => ({
			...acc,
			[key]: text,
		}),
		{},
	);

	return [
		{
			header: t("type", "Type"),
			attribute: "type",
			renderItem: ({ label }) => articleTypeTranslations[label],
		},
		{
			header: t("status", "Status"),
			attribute: "status",
			collapsed: true,
			renderItem: ({ label }) => articleStatusTranslations[label],
		},
		{
			header: t("publicationStatus", "Publication status"),
			attribute: "publicationStatus",
			collapsed: true,
			renderItem: ({ label }) => publicationStatusTranslations[label],
		},

		{
			header: t("distribution", "Distribution"),
			attribute: "delivery.status",
			collapsed: true,
			renderItem: ({ label }) => deliveryStatuses[label]?.text,
		},
		{
			header: t("publisher", "Publisher"),
			attribute: "publisher.name",
			searchable: true,
			collapsed: true,
			hidden: !!organization,
		},
		{
			header: t("channels", "Channels"),
			attribute: "channelIds",
			collapsed: true,
			renderItem: ({ label }) => channels?.find(({ id }) => id === label)?.name,
		},
		{
			header: t("imprint", "Imprint"),
			attribute: "imprint.name",
			searchable: true,
			collapsed: true,
		},
		{
			header: t("language", "Language"),
			attribute: "language",
			searchable: true,
			collapsed: true,
			renderItem: ({ label }) => languageName(label),
		},
		{
			header: t("author", "Author"),
			attribute: "authors",
			searchable: true,
			collapsed: true,
		},
		{
			header: t("narrator", "Narrator"),
			attribute: "narrators",
			searchable: true,
			collapsed: true,
		},
		{
			header: t("translator", "Translator"),
			attribute: "translators",
			searchable: true,
			collapsed: true,
		},
		{
			header: t("serie", "Series"),
			attribute: "serie.name",
			searchable: true,
			collapsed: true,
		},
		{
			header: t("tags", "Tags"),
			attribute: "tags",
			searchable: true,
			collapsed: true,
		},
		{
			header: t("created", "Created"),
			attribute: "created._seconds",
			type: "dateRange",
			collapsed: true,
		},
		{
			header: t("releaseDate", "Release date"),
			attribute: "releaseDates",
			type: "dateRange",
			collapsed: true,
		},
		{
			header: t("takedownDate", "Takedown date"),
			attribute: "takedownDates",
			type: "dateRange",
			collapsed: true,
		},
		{
			header: t("announcementDate", "Announcement date"),
			attribute: "announcementDates",
			type: "dateRange",
			collapsed: true,
		},
	];
}
